export const FETCH_COMMERCE_LINKS_LIST = 'COMMERCE/FETCH_COMMERCE_LINKS_LIST';
export const FETCH_COMMERCE_LINKS_LIST_ERROR = 'COMMERCE/FETCH_COMMERCE_LINKS_LIST';
export const CLEAR_FETCH_COMMERCE_LINKS_LIST = 'COMMERCE/CLEAR_FETCH_COMMERCE_LINKS_LIST';

export const APPLY_COMMERCE_LINK_DRAG = 'COMMERCE/APPLY_COMMERCE_LINK_DRAG';
export const APPLY_COMMERCE_LINK_DRAG_ERROR = 'COMMERCE/APPLY_COMMERCE_LINK_DRAG_ERROR';
export const CLEAR_COMMERCE_LINK_DRAG = 'COMMERCE/CLEAR_COMMERCE_LINK_DRAG';

export const ADD_COMMERCE_LINK_SUCCESS = 'COMMERCE/ADD_COMMERCE_LINK_SUCCESS';
export const ADD_COMMERCE_LINK_ERROR = 'COMMERCE/ADD_COMMERCE_LINK_ERROR';
export const CLEAR_ADD_COMMERCE_LINK = 'COMMERCE/CLEAR_ADD_COMMERCE_LINK';

export const PATCH_COMMERCE_LINK_SUCCESS = 'COMMERCE/PATCH_COMMERCE_LINK_SUCCESS';
export const PATCH_COMMERCE_LINK_ERROR = 'COMMERCE/PATCH_COMMERCE_LINK_ERROR';
export const CLEAR_PATCH_COMMERCE_LINK = 'COMMERCE/CLEAR_PATCH_COMMERCE_LINK';

export const DELETE_COMMERCE_LINK_SUCCESS = 'COMMERCE/DELETE_COMMERCE_LINK_SUCCESS';
export const DELETE_COMMERCE_LINK_ERROR = 'COMMERCE/DELETE_COMMERCE_LINK_ERROR';
export const CLEAR_DELETE_COMMERCE_LINK = 'COMMERCE/CLEAR_DELETE_COMMERCE_LINK';

export const ADD_COMMERCE_AMOUNT_SUCCESS = 'COMMERCE/ADD_COMMERCE_AMOUNT_SUCCESS';
export const ADD_COMMERCE_AMOUNT_ERROR = 'COMMERCE/ADD_COMMERCE_AMOUNT_ERROR';
export const CLEAR_ADD_COMMERCE_AMOUNT = 'COMMERCE/CLEAR_ADD_COMMERCE_AMOUNT';

export const PATCH_COMMERCE_AMOUNT_SUCCESS = 'COMMERCE/PATCH_COMMERCE_AMOUNT_SUCCESS';
export const PATCH_COMMERCE_AMOUNT_ERROR = 'COMMERCE/PATCH_COMMERCE_AMOUNT_ERROR';
export const CLEAR_PATCH_COMMERCE_AMOUNT = 'COMMERCE/CLEAR_PATCH_COMMERCE_AMOUNT';

export const DELETE_COMMERCE_AMOUNT_SUCCESS = 'COMMERCE/DELETE_COMMERCE_AMOUNT_SUCCESS';
export const DELETE_COMMERCE_AMOUNT_ERROR = 'COMMERCE/DELETE_COMMERCE_AMOUNT_ERROR';
export const CLEAR_DELETE_COMMERCE_AMOUNT = 'COMMERCE/CLEAR_DELETE_COMMERCE_AMOUNT';

export const CREATE_STRIPE_ACCOUNT_SUCCESS = 'SETTINGS/CREATE_STRIPE_ACCOUNT_SUCCESS';
export const CREATE_STRIPE_ACCOUNT_ERROR = 'SETTINGS/CREATE_STRIPE_ACCOUNT_ERROR';
export const CLEAR_CREATE_STRIPE_ACCOUNT = 'SETTINGS/CLEAR_CREATE_STRIPE_ACCOUNT';

export const CONNECT_STRIPE_ACCOUNT_SUCCESS = 'SETTINGS/CONNECT_STRIPE_ACCOUNT_SUCCESS';
export const CONNECT_STRIPE_ACCOUNT_ERROR = 'SETTINGS/CONNECT_STRIPE_ACCOUNT_ERROR';
export const CLEAR_CONNECT_STRIPE_ACCOUNT = 'SETTINGS/CLEAR_CONNECT_STRIPE_ACCOUNT';
